// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.calendar-container {
    height: 100%;
    min-width: 300px;
    display: flex;
    flex-direction: column;
}
.calendar-weekly-content {
    height: 100%;
    border: .05rem solid #e0e0e0;
    border-radius: 5px;
    overflow: auto;
    overscroll-behavior-x: none;
}
.calendar-body {
    border: .05rem solid #e0e0e0;
    border-radius: 5px;
    cursor: pointer;
}
.calendar-rows {
    display: grid;
    grid-template-columns: repeat(7, minmax(40px,1fr));
}
.month, .week {
    flex-grow: 1;
    height: 100%;
}
.calendar-rows.week {
    grid-template-columns: 58px repeat(7, minmax(90px,1fr));
    position: relative;
}
.calendar-rows.daily {
    grid-template-columns: 58px 1fr;
    position: relative;
}
.weekday-name-row {
    font-weight: bolder;
    text-align: center;
    height: 24px;
}
.empty-cell {
    background-color: #a8a8a810;
    height: 100%;
    width: 100%;
}

  /* Shift cell (monthly and weekly) styles */
.day-cell-wrapper {
    border: .05rem solid #e0e0e070;
    text-align: center;
    height: 100%;
    cursor: pointer;
}
.weekly-day-cell-wrapper {
    border-right: .05rem solid transparent;
}
.day-cell-wrapper:not(.empty-cell):hover,
  .weekly-cell-header:not(.daily-header):hover {
    border: .05rem solid #52a3d58b;
    border-radius: 7px;
    background-color: #eef6fb;
    transition: .2s ease;
}
.day-cell-wrapper:not(.empty-cell):has(.weekly-cell-header:not(.daily-header):hover) {
    border: unset;
    border-left: .05rem solid #e0e0e070;
    border-radius: 0;
    background-color: #fff;
}
.day-cell {
    display: flex;
    justify-content: left;
    align-items: flex-start;
    gap: 5px;
    min-height: 41px;
    height: 99%;
    width: 100%;
    overflow: hidden;
    position: relative;
    padding: 5px 10px;
}
.day-cell-content {
    position: absolute;
    width: 90%;
    top: 30%;
    left: 50%;
    gap: 10px;
    transform: translate(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    height: -webkit-fill-available;
    height: fill-available;
    height: -moz-available;
}
.today-cell {
    line-height: 0;
    background-color: #ffce41;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.cell-details-container {
    position: fixed;
    display: block;
    overflow: hidden;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    z-index: 100000;
}
.cell-details-overlay {
    background: rgba(247,248,249,.6);
    cursor: default;
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
}
.cell-details-card {
    text-align: center;
    width: 270px;
    height: auto;
    max-height: 450px;
    min-height: 275px;
    background-color: #fff;
    z-index: 100001;
    box-shadow: 0px 1px 4px 1px #8e8e8e91;
    padding: 10px 10px;
    border-radius: 5px;
    position: relative;
    display: flex;
    flex-direction: column;
}
.card-date-text {
    padding-bottom: 5px;
    border-bottom: .05rem solid #e0e0e0;
}
.add-slot-button-wrapper {
    margin-top: auto;
    padding-top: 10px;
    border-top: .05rem solid #e0e0e0;
}
.empty-slot-text {
    font-size: .6rem;
}
.cell-add-button {
    position: absolute;
    top: 0;
    right: 0;
    padding: 4px;
}
.calendar-slots {
    gap: 8px;
}
.calendar-slots-container {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 12px 20px;
}
.calendar-slots-cell {
    pointer-events: none;
    width: 95%;
}
.time-range-container {
    margin: .05rem 0;
    z-index: 3;
    position: sticky;
    left: 0;
    background: #fff;
}
.time-cell-sticky {
    position: sticky;
    left: 0;
    z-index: 5;
    background-color: #fff;
}
.time-cell-wrapper {
    position: relative;
    display: grid;
    margin-top: 0.1rem;
}
.calendar-weekly-content .time-cell {
    border-top: .05rem solid #e0e0e0;
    width: 100%;
}
.time-range-wrapper {
    width: 100%;
    height: 100%;
    display: grid;
}
.time-text-wrapper {
    position: relative;
}
.time-text{
    position: absolute;
    top: -25%;
    height: 50%;
    width: 58px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    background-color: #fff;
}
.weekly-calendar-corner-cell {
    position: sticky;
    left: 0;
    top: 0;
    background: linear-gradient(#fff 50%, transparent 50%);
    z-index: 4;
}
@media (max-width: 576px) {
.cell-details-card.monthly-modal {
      width: 160px;
      height: 275px;
}
.day-cell {
      display: block;
      font-size: .7rem;
}
.today-cell {
      height: 25px;
      width: 25px;
}
.cell-add-button {
      top: auto;
      bottom: 0;
      left: 0;
}
.date-label-wrapper {
      display: flex;
      justify-content: center;
      line-height: normal;
      padding: 8px 0 13px 0;
}
.date-label-wrapper .today-cell {
      padding: 5px 0;
}
}
@media (max-width: 430px) {
.calendar-rows.week {
      width: fit-content;
}
}
@media (max-width: 300px)  {
.card-date-text {
      font-size: .6rem;
}
.cell-details-card.monthly-modal {
      width: 130px;
}
}
@media (max-height: 990px) {
.day-cell-content {
      padding-top: 13px;
}
}

  /* ANIMATION CLASSES */
.fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.2s;
}
.fade-enter-from,
  .fade-leave-to {
    opacity: 0;
}
.left-fade-enter-active,
  .right-fade-enter-active,
  .top-fade-enter-active {
    transition: all 0.2s ease-in-out;
}
.left-fade-leave-active,
  .right-fade-leave-active,
  .top-fade-leave-active {
    transition: all 0.2s linear;
}
.left-fade-enter-from,
  .left-fade-leave-to {
    transform: translateX(-20px);
    opacity: 0;
}
.right-fade-enter-from,
  .right-fade-leave-to {
    transform: translateX(20px);
    opacity: 0;
}
.top-fade-enter-from,
  .top-fade-leave-to {
    transform: translateY(-20px);
    opacity: 0;
}
.slot-memo {
    margin: 5px 10px;
    font-size: 12px;
    text-align: left;
    white-space: pre-wrap;
}
.slot-memo-container {
    display: flex;
    overflow: hidden;
    border: 1px solid;
    border-radius: 5px;
    width: 95%;
}

  /* Shift cell style END */
@media (max-width: 769px) {
.month {
      height: 70px;
}
}
@media (max-width: 576px) {
.month {
      height: 50px;
}
}
`, "",{"version":3,"sources":["webpack://./src/vue/ShiftCalendar.vue"],"names":[],"mappings":";AA2LE;IACE,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AACxB;AAEA;IACE,YAAY;IACZ,4BAA4B;IAC5B,kBAAkB;IAClB,cAAc;IACd,2BAA2B;AAC7B;AAEA;IACE,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;AACjB;AAEA;IACE,aAAa;IACb,kDAAkD;AACpD;AAEA;IACE,YAAY;IACZ,YAAY;AACd;AAEA;IACE,uDAAuD;IACvD,kBAAkB;AACpB;AAEA;IACE,+BAA+B;IAC/B,kBAAkB;AACpB;AAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AACd;AAEA;IACE,2BAA2B;IAC3B,YAAY;IACZ,WAAW;AACb;;EAEA,2CAA2C;AAE3C;IACE,8BAA8B;IAC9B,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACjB;AAEA;IACE,sCAAsC;AACxC;AAEA;;IAEE,8BAA8B;IAC9B,kBAAkB;IAClB,yBAAyB;IACzB,oBAAoB;AACtB;AAEA;IACE,aAAa;IACb,mCAAmC;IACnC,gBAAgB;IAChB,sBAAsB;AACxB;AAEA;IACE,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACnB;AAEA;IACE,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,SAAS;IACT,SAAS;IACT,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,8BAA8B;IAC9B,sBAAsB;IACtB,sBAAsB;AACxB;AAEA;IACE,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACrB;AAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,MAAM;IACN,eAAe;AACjB;AAEA;IACE,gCAAgC;IAChC,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;AACX;AAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;IACf,qCAAqC;IACrC,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AACxB;AAEA;IACE,mBAAmB;IACnB,mCAAmC;AACrC;AAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;AAClC;AAEA;IACE,gBAAgB;AAClB;AAEA;IACE,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,YAAY;AACd;AAEA;IACE,QAAQ;AACV;AAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACpB;AAEA;IACE,oBAAoB;IACpB,UAAU;AACZ;AAEA;IACE,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,OAAO;IACP,gBAAgB;AAClB;AAEA;IACE,gBAAgB;IAChB,OAAO;IACP,UAAU;IACV,sBAAsB;AACxB;AAEA;IACE,kBAAkB;IAClB,aAAa;IACb,kBAAkB;AACpB;AAEA;IACE,gCAAgC;IAChC,WAAW;AACb;AAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;AACf;AAEA;IACE,kBAAkB;AACpB;AAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,sBAAsB;AACxB;AAEA;IACE,gBAAgB;IAChB,OAAO;IACP,MAAM;IACN,sDAAsD;IACtD,UAAU;AACZ;AAEA;AACE;MACE,YAAY;MACZ,aAAa;AACf;AACA;MACE,cAAc;MACd,gBAAgB;AAClB;AACA;MACE,YAAY;MACZ,WAAW;AACb;AACA;MACE,SAAS;MACT,SAAS;MACT,OAAO;AACT;AACA;MACE,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,qBAAqB;AACvB;AAEA;MACE,cAAc;AAChB;AACF;AAEA;AACE;MACE,kBAAkB;AACpB;AACF;AAEA;AACE;MACE,gBAAgB;AAClB;AACA;MACE,YAAY;AACd;AACF;AAEA;AACE;MACE,iBAAiB;AACnB;AACF;;EAEA,sBAAsB;AACtB;;IAEE,wBAAwB;AAC1B;AACA;;IAEE,UAAU;AACZ;AACA;;;IAGE,gCAAgC;AAClC;AACA;;;IAGE,2BAA2B;AAC7B;AACA;;IAEE,4BAA4B;IAC5B,UAAU;AACZ;AACA;;IAEE,2BAA2B;IAC3B,UAAU;AACZ;AAEA;;IAEE,4BAA4B;IAC5B,UAAU;AACZ;AAEA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACvB;AAEA;IACE,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;AACZ;;EAEA,yBAAyB;AAEzB;AACE;MACE,YAAY;AACd;AACF;AACA;AACE;MACE,YAAY;AACd;AACF","sourcesContent":["<script>\nimport ShiftCell from './ShiftCell.vue';\nimport ShiftWeeklyCell from './components/ShiftWeeklyCell.vue';\nimport { dateFromSecondsTimestamp, intToJapaneseWeekdayKanji, millisecondsFromSeconds } from '../js/common.js'\nimport { isMonthlyView, isWeeklyView, isDailyView } from '../js/shift';\nimport { fromOplusTime, yearMonthDateString } from '../common/common';\nimport { MeStore } from '../store/v1/meStore';\nimport timeZones from '../common/timeZones';\nimport TimeIndicator from './components/TimeIndicator.vue';\n\nexport default {\n  props: {\n    dates: Object, // All DayData object\n    branchSettings: Object,\n    meStore: MeStore,\n  },\n  data() {\n    return {\n      days: Object.values(intToJapaneseWeekdayKanji),\n      selectedCellDate: 0,\n      selectedRoleID: \"\",\n      cellHeight: 60,\n    }\n  },\n  methods: {\n    selectedCellHandler(date) {\n      return this.selectedCellDate = new Date(date).valueOf();\n    },\n    closePopup(event) {\n      event.stopPropagation();\n      return this.selectedCellDate = 0;\n    },\n    holidayClass(index) {\n      return {\n        \"th-saturday\": index === 6,\n        \"th-holiday\": index === 0,\n      }\n    },\n  },\n  computed: {\n    datesArray() {\n      const datesArray = [];\n      const startDate = new Date(millisecondsFromSeconds(this.dates[0].TimeStamp));\n      if (this.isCalendarDailyView) {\n        const oplusDate = dateFromSecondsTimestamp(this.dates[0].TimeStamp);\n        const realDate = fromOplusTime(oplusDate);\n        datesArray.push({\n          dateStr: yearMonthDateString(realDate, 'Asia/Tokyo'),\n          timeStamp: millisecondsFromSeconds(this.dates[0].TimeStamp),\n          isHoliday: this.dates[0].IsHoliday\n        });\n\n        return datesArray;\n      }\n      if (!this.isCalendarWeeklyView) {\n        // Padding before the month starts\n        for (let i = 0; i < startDate.getUTCDay(); i++) {\n          datesArray.push(\"\");\n        }\n      }\n\n      // Add each day of the month to the array\n      for (let i = 0; i < this.dates.length; i++) {\n        const oplusDate = dateFromSecondsTimestamp(this.dates[i].TimeStamp);\n        const realDate = fromOplusTime(oplusDate);\n        datesArray.push({\n          dateStr: yearMonthDateString(realDate, timeZones.ASIA_TOKYO),\n          timeStamp: millisecondsFromSeconds(this.dates[i].TimeStamp),\n          isHoliday: this.dates[i].IsHoliday\n        });\n      }\n\n      // Padding after the month ends\n      while (datesArray.length % 7 !== 0) {\n        datesArray.push(\"\");\n      }\n      return datesArray;\n    },\n    isCalendarMonthlyView() {\n      return isMonthlyView();\n    },\n    isCalendarWeeklyView() {\n      return isWeeklyView();\n    },\n    isCalendarDailyView() {\n      return isDailyView();\n    },\n    timeViewArray() {\n      const timeRangeArr = [];\n      const start = this.branchSettings.summaryDayStart;\n      const end = this.branchSettings.summaryDayEnd;  // end may be over 24 hours depending on working hours\n\n      for (let i = start; i < end; i++) {\n        timeRangeArr.push(i % 24);\n      }\n\n      return [...new Set(timeRangeArr)];\n    },\n    computedGridStyle() {\n      return {\n        \"gridTemplateRows\": `${this.cellHeight + 30}px repeat(${this.timeViewArray.length}, ${this.cellHeight}px)`\n      }\n    },\n    rowClass() {\n      return {\n        'week': this.isCalendarWeeklyView,\n        'daily': this.isCalendarDailyView,\n      }\n    }\n  },\n  components: {\n    ShiftCell,\n    ShiftWeeklyCell,\n    TimeIndicator,\n  },\n  inject: [\n    'calendarReactiveObject'\n  ],\n}\n</script>\n<template>\n  <!-- Monthly Calendar -->\n  <div v-if=\"calendarReactiveObject.isCalendarView && isCalendarMonthlyView\" id=\"shift-calendar\" class=\"calendar-container\">\n    <!-- TODO: Separate the Monthly calendar into a component, both Monthly and Weekly components should be under one parent component -->\n    <!-- Top most row, weekday name row -->\n    <div class=\"calendar-rows weekday-name-row\">\n      <div v-for=\"day, index in days\" class=\"day-name\" :key=\"index\">\n        <span :class=\"holidayClass(index)\">{{ day }}</span>\n      </div>\n    </div>\n    <!-- Main Calendar Body -->\n    <div class=\"calendar-body calendar-rows month\">\n      <div v-for=\"date, index in datesArray\" :key=\"index\">\n        <div v-if=\"!date\" class=\"day-cell-wrapper empty-cell\"></div>\n        <ShiftCell v-else\n          :cell-props=\"calendarReactiveObject.cellsMap[date.dateStr]\"\n          :cell-index=\"index\"\n          :is-selected=\"selectedCellDate === date.timeStamp\"\n          :is-holiday=\"date.isHoliday\"\n          :branch-settings=\"branchSettings\"\n          :date=\"date.dateStr\"\n          :me-store=\"meStore\"\n          @emit-selected-cell=\"selectedCellHandler\"\n          @emit-close-popup=\"closePopup\"\n        />\n      </div>\n    </div>\n  </div>\n\n  <!-- Weekly Calendar -->\n  <div v-if=\"calendarReactiveObject.isCalendarView && !isCalendarMonthlyView\" id=\"shift-weekly-calendar\" class=\"calendar-weekly-content\">\n    <div class=\"calendar-rows\" :class=\"rowClass\">\n      <TimeIndicator\n        :cell-height=\"cellHeight\"\n        :time-view=\"timeViewArray\"\n      />\n      <!-- Time range column -->\n      <div class=\"weekly-day-cell-wrapper time-cell-sticky\">\n        <div class=\"time-cell-wrapper\" :style=\"computedGridStyle\">\n          <div class=\"weekly-calendar-corner-cell\"></div>\n          <div v-for=\"time in timeViewArray\" class=\"time-cell time-text-wrapper\">\n            <span class=\"time-text\">{{ time + \":00\"  }}</span>\n          </div>\n        </div>\n      </div>\n\n      <div v-for=\"date, index in datesArray\" :key=\"index\" class=\"day-cell-wrapper weekly-day-cell-wrapper\">\n        <ShiftWeeklyCell\n          v-if=\"calendarReactiveObject.cellsMap[date.dateStr]\"\n          :cell-props=\"calendarReactiveObject.cellsMap[date.dateStr]\"\n          :is-cell-selected=\"selectedCellDate === date.timeStamp\"\n          :is-holiday=\"date.isHoliday\"\n          :time-view=\"timeViewArray\"\n          :branch-settings=\"branchSettings\"\n          :date=\"date.dateStr\"\n          :me-store=\"meStore\"\n          :cell-height=\"cellHeight\"\n          @emit-selected-cell=\"selectedCellHandler\"\n          @emit-close-popup=\"closePopup\"\n        />\n      </div>\n\n    </div>\n  </div>\n</template>\n\n<style>\n  .calendar-container {\n    height: 100%;\n    min-width: 300px;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .calendar-weekly-content {\n    height: 100%;\n    border: .05rem solid #e0e0e0;\n    border-radius: 5px;\n    overflow: auto;\n    overscroll-behavior-x: none;\n  }\n\n  .calendar-body {\n    border: .05rem solid #e0e0e0;\n    border-radius: 5px;\n    cursor: pointer;\n  }\n\n  .calendar-rows {\n    display: grid;\n    grid-template-columns: repeat(7, minmax(40px,1fr));\n  }\n\n  .month, .week {\n    flex-grow: 1;\n    height: 100%;\n  }\n\n  .calendar-rows.week {\n    grid-template-columns: 58px repeat(7, minmax(90px,1fr));\n    position: relative;\n  }\n\n  .calendar-rows.daily {\n    grid-template-columns: 58px 1fr;\n    position: relative;\n  }\n\n  .weekday-name-row {\n    font-weight: bolder;\n    text-align: center;\n    height: 24px;\n  }\n\n  .empty-cell {\n    background-color: #a8a8a810;\n    height: 100%;\n    width: 100%;\n  }\n\n  /* Shift cell (monthly and weekly) styles */\n\n  .day-cell-wrapper {\n    border: .05rem solid #e0e0e070;\n    text-align: center;\n    height: 100%;\n    cursor: pointer;\n  }\n\n  .weekly-day-cell-wrapper {\n    border-right: .05rem solid transparent;\n  }\n\n  .day-cell-wrapper:not(.empty-cell):hover,\n  .weekly-cell-header:not(.daily-header):hover {\n    border: .05rem solid #52a3d58b;\n    border-radius: 7px;\n    background-color: #eef6fb;\n    transition: .2s ease;\n  }\n\n  .day-cell-wrapper:not(.empty-cell):has(.weekly-cell-header:not(.daily-header):hover) {\n    border: unset;\n    border-left: .05rem solid #e0e0e070;\n    border-radius: 0;\n    background-color: #fff;\n  }\n\n  .day-cell {\n    display: flex;\n    justify-content: left;\n    align-items: flex-start;\n    gap: 5px;\n    min-height: 41px;\n    height: 99%;\n    width: 100%;\n    overflow: hidden;\n    position: relative;\n    padding: 5px 10px;\n  }\n\n  .day-cell-content {\n    position: absolute;\n    width: 90%;\n    top: 30%;\n    left: 50%;\n    gap: 10px;\n    transform: translate(-50%);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    overflow: hidden;\n    height: -webkit-fill-available;\n    height: fill-available;\n    height: -moz-available;\n  }\n\n  .today-cell {\n    line-height: 0;\n    background-color: #ffce41;\n    border-radius: 50%;\n    width: 30px;\n    height: 30px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .cell-details-container {\n    position: fixed;\n    display: block;\n    overflow: hidden;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    top: 0;\n    z-index: 100000;\n  }\n\n  .cell-details-overlay {\n    background: rgba(247,248,249,.6);\n    cursor: default;\n    display: block;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n  }\n\n  .cell-details-card {\n    text-align: center;\n    width: 270px;\n    height: auto;\n    max-height: 450px;\n    min-height: 275px;\n    background-color: #fff;\n    z-index: 100001;\n    box-shadow: 0px 1px 4px 1px #8e8e8e91;\n    padding: 10px 10px;\n    border-radius: 5px;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .card-date-text {\n    padding-bottom: 5px;\n    border-bottom: .05rem solid #e0e0e0;\n  }\n\n  .add-slot-button-wrapper {\n    margin-top: auto;\n    padding-top: 10px;\n    border-top: .05rem solid #e0e0e0;\n  }\n\n  .empty-slot-text {\n    font-size: .6rem;\n  }\n\n  .cell-add-button {\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 4px;\n  }\n\n  .calendar-slots {\n    gap: 8px;\n  }\n\n  .calendar-slots-container {\n    height: 100%;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding: 12px 20px;\n  }\n\n  .calendar-slots-cell {\n    pointer-events: none;\n    width: 95%;\n  }\n\n  .time-range-container {\n    margin: .05rem 0;\n    z-index: 3;\n    position: sticky;\n    left: 0;\n    background: #fff;\n  }\n\n  .time-cell-sticky {\n    position: sticky;\n    left: 0;\n    z-index: 5;\n    background-color: #fff;\n  }\n\n  .time-cell-wrapper {\n    position: relative;\n    display: grid;\n    margin-top: 0.1rem;\n  }\n\n  .calendar-weekly-content .time-cell {\n    border-top: .05rem solid #e0e0e0;\n    width: 100%;\n  }\n\n  .time-range-wrapper {\n    width: 100%;\n    height: 100%;\n    display: grid;\n  }\n\n  .time-text-wrapper {\n    position: relative;\n  }\n\n  .time-text{\n    position: absolute;\n    top: -25%;\n    height: 50%;\n    width: 58px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 14px;\n    background-color: #fff;\n  }\n\n  .weekly-calendar-corner-cell {\n    position: sticky;\n    left: 0;\n    top: 0;\n    background: linear-gradient(#fff 50%, transparent 50%);\n    z-index: 4;\n  }\n\n  @media (max-width: 576px) {\n    .cell-details-card.monthly-modal {\n      width: 160px;\n      height: 275px;\n    }\n    .day-cell {\n      display: block;\n      font-size: .7rem;\n    }\n    .today-cell {\n      height: 25px;\n      width: 25px;\n    }\n    .cell-add-button {\n      top: auto;\n      bottom: 0;\n      left: 0;\n    }\n    .date-label-wrapper {\n      display: flex;\n      justify-content: center;\n      line-height: normal;\n      padding: 8px 0 13px 0;\n    }\n\n    .date-label-wrapper .today-cell {\n      padding: 5px 0;\n    }\n  }\n\n  @media (max-width: 430px) {\n    .calendar-rows.week {\n      width: fit-content;\n    }\n  }\n\n  @media (max-width: 300px)  {\n    .card-date-text {\n      font-size: .6rem;\n    }\n    .cell-details-card.monthly-modal {\n      width: 130px;\n    }\n  }\n\n  @media (max-height: 990px) {\n    .day-cell-content {\n      padding-top: 13px;\n    }\n  }\n\n  /* ANIMATION CLASSES */\n  .fade-enter-active,\n  .fade-leave-active {\n    transition: opacity 0.2s;\n  }\n  .fade-enter-from,\n  .fade-leave-to {\n    opacity: 0;\n  }\n  .left-fade-enter-active,\n  .right-fade-enter-active,\n  .top-fade-enter-active {\n    transition: all 0.2s ease-in-out;\n  }\n  .left-fade-leave-active,\n  .right-fade-leave-active,\n  .top-fade-leave-active {\n    transition: all 0.2s linear;\n  }\n  .left-fade-enter-from,\n  .left-fade-leave-to {\n    transform: translateX(-20px);\n    opacity: 0;\n  }\n  .right-fade-enter-from,\n  .right-fade-leave-to {\n    transform: translateX(20px);\n    opacity: 0;\n  }\n\n  .top-fade-enter-from,\n  .top-fade-leave-to {\n    transform: translateY(-20px);\n    opacity: 0;\n  }\n\n  .slot-memo {\n    margin: 5px 10px;\n    font-size: 12px;\n    text-align: left;\n    white-space: pre-wrap;\n  }\n\n  .slot-memo-container {\n    display: flex;\n    overflow: hidden;\n    border: 1px solid;\n    border-radius: 5px;\n    width: 95%;\n  }\n\n  /* Shift cell style END */\n\n  @media (max-width: 769px) {\n    .month {\n      height: 70px;\n    }\n  }\n  @media (max-width: 576px) {\n    .month {\n      height: 50px;\n    }\n  }\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
